// extracted by mini-css-extract-plugin
export var brandShape = "CategoryButtonSection-module--brand-shape--Z8R13";
export var categoryButton = "CategoryButtonSection-module--category-button--BjV0H";
export var categoryButtonSection = "CategoryButtonSection-module--category-button-section--gNmxI";
export var categoryButtons = "CategoryButtonSection-module--category-buttons--1whKD";
export var primary = "#06004d";
export var secondary = "#4dafd7";
export var wrapper = "CategoryButtonSection-module--wrapper--ab7j1";